export enum RaffleAffiliateStatusEnum {
  ACTIVE = "a",
  INACTIVE = "i",
  DELETED = "x",
  OWNER_REQUEST = "or", // Owner Request
  OWNER_REJECTED = "ro", // Rejected by Owner
  OWNER_BLOCK = "ob", // Blocked by Owner (Customer don't send Request anymore)
  CUSTOMER_REQUEST = "cr", // Customer Request
  CUSTOMER_REJECTED = "rc", // Rejected by Custmoer
  CUSTOMER_BLOCK = "cb", // Blocked by Custmoer (Owner don't send Request anymore)
}

export type RaffleAffiliateStatusTypes = `${RaffleAffiliateStatusEnum}`;
